import React from "react";
import './CommercialList.css';
import Img1 from './assets/img-1.png';
import Img2 from './assets/img-2.png';
import Img3 from './assets/img-3.png';
import Img4 from './assets/img-4.png';
import Img5 from './assets/img-5.png';
import Img6 from './assets/img-6.png';
import Img7 from './assets/img-7.png';
import Img8 from './assets/img-8.png';
import Img9 from './assets/img-9.png';
import Img10 from './assets/img-10.png';
import Title from "../../ui/title/Title";
import InfiniteLooper from "../../ui/infiniteLooper/InfiniteLooper";

export default function CommercialList()
{
    return (
        <section className="commercial-list">
            <Title props={{type: 'section-title', title: 'Нам доверяют'}}/>
           
                <InfiniteLooper speed="25" direction="right">
                    <img className="img1" style={{userSelect: 'none', marginLeft: "60px"}} src={Img1} alt="img1"></img>
                    <img className="img2" style={{userSelect: 'none', pointerEvents: 'none'}} src={Img2} alt="img2"></img>
                    <img className="img3" style={{userSelect: 'none', pointerEvents: 'none'}} src={Img3} alt="img3"></img>
                    <img className="img4" style={{userSelect: 'none', pointerEvents: 'none'}} src={Img4} alt="img4"></img>
                    <img className="img5" style={{userSelect: 'none', pointerEvents: 'none'}} src={Img5} alt="img5"></img>
                    <img className="img6" style={{userSelect: 'none', pointerEvents: 'none'}} height={220} src={Img6} alt="img6"></img>
                    <img className="img7" style={{userSelect: 'none', pointerEvents: 'none'}} height={220} src={Img7} alt="img7"></img>
                    <img className="img8" style={{userSelect: 'none', pointerEvents: 'none'}} height={220} src={Img8} alt="img8"></img>
                    <img className="img9" style={{userSelect: 'none', pointerEvents: 'none'}} height={220} src={Img9} alt="img9"></img>
                    <img className="img10" style={{userSelect: 'none', pointerEvents: 'none'}}  src={Img10} alt="img10"></img>
                </InfiniteLooper>
        </section>
    )
}